var _circle, _defs, _clipPath, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigYellowPlanet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "322.572px",
    height: "322.572px",
    viewBox: "0 0 322.572 322.572",
    enableBackground: "new 0 0 322.572 322.572",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 161.2861,
    x2: 322.5723,
    y2: 161.2861
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0081,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_1_)",
    cx: 161.286,
    cy: 161.286,
    r: 161.286
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_2_",
    cx: 161.884,
    cy: 162.036,
    r: 138.354
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_2_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 88.8257,
    y1: 70.7778,
    x2: 247.6273,
    y2: 269.1365
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEE62A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1378,
    style: {
      stopColor: "#FDD82B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3964,
    style: {
      stopColor: "#F9B42C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7453,
    style: {
      stopColor: "#F37B2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9911,
    style: {
      stopColor: "#EF4E31"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    clipPath: "url(#SVGID_3_)",
    fill: "url(#SVGID_4_)",
    cx: 161.884,
    cy: 162.036,
    r: 138.354
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    clipPath: "url(#SVGID_3_)",
    fill: "#EF4E31",
    d: "M140.879,33.891c-2.788,1.768-5.609,4.613-4.982,7.854 c0.635,3.275,4.356,4.843,7.613,5.568c9.055,2.016,18.605,1.76,27.54-0.737c2.014-0.563,4.04-1.261,5.689-2.546 s2.882-3.261,2.803-5.351c-0.24-6.363-10.063-9.615-15.084-10.163C156.297,27.626,147.824,29.488,140.879,33.891z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    clipPath: "url(#SVGID_3_)",
    fill: "#EF4E31",
    d: "M139.532,83.318c-1.679,1.234-3.223,2.752-4.051,4.664 c-0.829,1.912-0.833,4.272,0.383,5.965c1.942,2.706,5.922,2.721,9.21,2.187c3.564-0.578,7.077-1.479,10.48-2.687 c2.798-0.993,5.686-2.327,7.283-4.83c3.355-5.255-1.402-8.635-5.98-9.341C150.813,78.346,144.494,79.671,139.532,83.318z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    clipPath: "url(#SVGID_3_)",
    fill: "#EF4E31",
    d: "M147.081,129.36c1.451,1.48,3.778,1.657,5.832,1.374 c5.802-0.799,11.165-9.384,3.39-11.571C151.361,117.773,142.018,124.198,147.081,129.36z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    clipPath: "url(#SVGID_3_)",
    fill: "#EF4E31",
    d: "M166.955,69.738c1.451,1.48,3.778,1.657,5.833,1.374 c5.801-0.799,11.164-9.384,3.389-11.571C171.236,58.151,161.892,64.576,166.955,69.738z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    clipPath: "url(#SVGID_3_)",
    fill: "#EF4E31",
    d: "M213.044,142.241c-0.908,2.822-0.526,6.414,1.955,8.036 c1.576,1.029,3.619,1.021,5.466,0.651c2.562-0.513,5.035-1.686,6.832-3.582c1.797-1.896,2.854-4.555,2.545-7.148 C228.488,128.862,215.382,134.971,213.044,142.241z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    clipPath: "url(#SVGID_3_)",
    fill: "#EF4E31",
    d: "M172.709,125.197c-4.125,4.735-5.309,11.339-5.584,17.612 c-0.3,6.822,0.283,13.684,1.729,20.358c1.204,5.555,3.607,11.652,8.914,13.688c3.998,1.533,8.668,0.196,12.03-2.456 c3.362-2.65,5.63-6.435,7.552-10.261c3.805-7.575,6.598-16.066,5.336-24.449C200.77,126.96,183.957,112.288,172.709,125.197z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    clipPath: "url(#SVGID_3_)",
    fill: "#EF4E31",
    d: "M101.376,117.512c-4.278,5.517-6.836,12.665-5.646,19.543 s6.682,13.157,13.605,14.05c4.212,0.543,8.501-0.87,12.068-3.174c7.256-4.687,11.848-13.236,11.747-21.873 c-0.083-7.137-4.082-18.323-11.937-20.281C113.722,103.908,105.459,112.247,101.376,117.512z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    clipPath: "url(#SVGID_3_)",
    fill: "#EF4E31",
    d: "M87.023,56.552C78.085,62.616,71.525,72.094,69,82.596 c-1.129,4.696-1.1,10.485,2.77,13.377c3.942,2.945,9.54,1.232,13.998-0.854c9.994-4.679,19.346-10.729,27.71-17.929 c3.939-3.391,7.786-7.228,9.486-12.139c2.465-7.125-0.757-15.299-8.551-15.991C104.946,48.219,94.823,51.261,87.023,56.552z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    clipPath: "url(#SVGID_3_)",
    fill: "#EF4E31",
    d: "M212.688,171.623c-3.665,2.556-5.96,6.619-7.86,10.663 c-4.198,8.938-7.077,18.495-8.516,28.265c-0.751,5.109-0.995,10.741,1.935,14.993c2.334,3.388,6.427,5.319,10.531,5.605 c4.104,0.285,8.203-0.932,11.852-2.833c9.787-5.101,16.646-15.429,17.55-26.429c0.719-8.759-2.354-17.54-7.988-24.221 C225.35,171.927,220.868,165.92,212.688,171.623z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    clipPath: "url(#SVGID_3_)",
    fill: "#EF4E31",
    d: "M151.854,216.16c-1.165,1.577-2.169,3.33-2.518,5.26 c-0.348,1.931,0.042,4.066,1.372,5.508c1.454,1.575,3.797,2.08,5.92,1.787c2.124-0.293,4.084-1.273,5.97-2.294 c3.874-2.096,7.684-4.47,10.607-7.765c4.564-5.146,6.449-13.694-3.006-12.926C163.086,206.308,156.062,210.466,151.854,216.16z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    clipPath: "url(#SVGID_3_)",
    fill: "#EF4E31",
    d: "M127.503,157.165c-1.082,4.604,1.259,9.592,5.058,12.41 c3.799,2.817,8.789,3.674,13.494,3.188c8.147-0.842,17.153-8.063,13.36-17.139c-2.989-7.153-14.242-9.033-20.948-7.774 C133.578,148.768,128.694,152.097,127.503,157.165z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    clipPath: "url(#SVGID_3_)",
    fill: "#EF4E31",
    d: "M125.151,208.839c1.306,2.11,4.106,3.021,6.523,2.46 c5.479-1.273,9.552-10.199,3.36-13.39C129.331,194.971,121.807,203.433,125.151,208.839z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    clipPath: "url(#SVGID_3_)",
    fill: "#EF4E31",
    d: "M246.192,174.633c0.033,0.924,0.488,1.875,1.311,2.301 c3.049,1.577,9.52-4.596,6.535-7.68C250.567,165.668,246.061,171.066,246.192,174.633z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    clipPath: "url(#SVGID_3_)",
    fill: "#EF4E31",
    d: "M248.977,129.325c-2.361,0.855-4.805,2.661-4.805,5.171 c0,2.481,2.35,4.254,4.537,5.425c2.693,1.442,5.609,2.643,8.664,2.726c3.053,0.084,6.277-1.125,7.98-3.662 C272.079,128.969,254.399,127.358,248.977,129.325z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    clipPath: "url(#SVGID_3_)",
    fill: "#EF4E31",
    d: "M183.582,73.847c-5.262,6.757-4.936,16.869-0.362,24.109 c4.573,7.239,12.718,11.731,21.141,13.274c5.994,1.099,12.821,0.601,17.22-3.617c5.338-5.118,5.115-14.098,1.51-20.555 C216.319,74.932,195.519,58.521,183.582,73.847z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    clipPath: "url(#SVGID_3_)",
    fill: "#EF4E31",
    d: "M219.851,47.631c-2.938,0.299-5.919,2.421-6.144,5.366 c-0.254,3.345,2.95,5.926,6.078,7.135c2.433,0.94,5.128,1.452,7.655,0.811c2.527-0.641,4.82-2.633,5.246-5.205 C233.668,49.817,224.138,47.196,219.851,47.631z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    clipPath: "url(#SVGID_3_)",
    fill: "#EF4E31",
    d: "M240.163,71.334c-2.592,3.49-1.543,8.423,0.031,12.476 c2.646,6.819,6.467,13.183,11.24,18.725c2.475,2.871,5.549,5.688,9.328,5.949c4.141,0.286,8.027-2.823,9.48-6.712 C274.409,90.619,251.625,55.901,240.163,71.334z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    clipPath: "url(#SVGID_3_)",
    fill: "#EF4E31",
    d: "M272.403,170.761c0.609,2.508,2.803,4.668,5.379,4.84 c3.295,0.219,6.01-2.604,7.549-5.525c2.193-4.167,1.688-11.327-4.527-11.15C275.715,159.068,271.286,166.164,272.403,170.761z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    clipPath: "url(#SVGID_3_)",
    fill: "#EF4E31",
    d: "M266.526,217.457c1.754,1.452,4.328,1.594,6.475,0.833 c8.451-2.996,17.621-18.845,5.551-23.249C268.172,191.253,259.174,211.366,266.526,217.457z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    clipPath: "url(#SVGID_3_)",
    fill: "#EF4E31",
    d: "M228.676,253.016c-0.77,9.118,5.811,18.574,14.829,20.124 c5.555,0.953,11.215-0.904,16.283-3.368c9.494-4.617,20.82-15.767,14.063-27.101c-6.387-10.713-23.969-12.585-33.926-6.69 C233.875,239.562,229.276,245.908,228.676,253.016z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    clipPath: "url(#SVGID_3_)",
    fill: "#EF4E31",
    d: "M167.682,259.559c-2.795,2.172-5.419,5.013-5.845,8.527 c-0.584,4.819,3.405,9.314,8.059,10.698c4.652,1.385,9.689,0.303,14.234-1.402c3.325-1.248,6.583-2.865,9.132-5.339 c5.288-5.132,6.097-15.837-1.634-19.202C184.117,249.57,173.45,255.078,167.682,259.559z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    clipPath: "url(#SVGID_3_)",
    fill: "#EF4E31",
    d: "M134.959,241.976c-2.574-0.746-5.654-0.373-7.452,1.614 c-2.271,2.51-1.718,6.422-0.758,9.667c1.008,3.408,2.338,6.775,4.48,9.611s5.179,5.115,8.668,5.794 c3.489,0.678,7.412-0.456,9.587-3.268c2.396-3.099,2.272-7.608,0.594-11.147C147.441,248.69,140.837,243.678,134.959,241.976z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    clipPath: "url(#SVGID_3_)",
    fill: "#EF4E31",
    d: "M83.994,207.513c4.461,6.03,11.541,10.747,19.015,10.103 c9.102-0.785,16.072-9.622,16.95-18.716c0.879-9.093-3.189-18.046-8.78-25.271c-2.992-3.867-6.566-7.47-11.067-9.38 C74.541,153.395,74.451,194.612,83.994,207.513z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    clipPath: "url(#SVGID_3_)",
    fill: "#EF4E31",
    d: "M62.823,156.195c3.534,1.095,7.345-0.8,10.056-3.318 c6.871-6.384,6.769-22.58-5.793-18.951C58.989,136.265,51.855,152.799,62.823,156.195z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    clipPath: "url(#SVGID_3_)",
    fill: "#EF4E31",
    d: "M17.748,119.71c-0.447,4.867-0.299,9.925,1.617,14.422 c1.916,4.496,5.875,8.347,10.709,9.068c6.856,1.023,13.017-4.185,17.389-9.565c4.741-5.835,8.735-12.488,10.224-19.858 c1.488-7.369,0.194-15.545-4.637-21.306C33.559,69.227,19.196,103.949,17.748,119.71z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    clipPath: "url(#SVGID_3_)",
    fill: "#EF4E31",
    d: "M54.869,230.702c-5.294-1.566-11.724-2.065-15.664,1.801 c-4.005,3.932-3.537,10.492-2,15.89c4.377,15.366,15.332,28.739,29.537,36.054c7.035,3.623,16.527,5.427,22.18-0.111 c8.504-8.332,0.875-22.684-3.853-31.068C78.891,242.31,66.729,234.213,54.869,230.702z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    clipPath: "url(#SVGID_3_)",
    fill: "#EF4E31",
    d: "M95.832,243.262c1.923,3,6.396,3.989,9.404,2.079 s4.018-6.378,2.121-9.396c-1.897-3.018-6.361-4.045-9.387-2.162c-3.025,1.884-4.073,6.343-2.202,9.377"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    clipPath: "url(#SVGID_3_)",
    fill: "#EF4E31",
    d: "M49.609,207.716c2.269,2.413,5.853,4.431,8.767,2.855 c2.542-1.374,3.15-4.72,3.196-7.609c0.066-4.264-0.466-8.536-1.577-12.653c-1.82-6.741-9.349-14.332-14.952-6.391 C40.136,190.874,44.498,202.277,49.609,207.716z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 132.8506,
    y1: 57.0083,
    x2: 181.3047,
    y2: 144.8313,
    gradientTransform: "matrix(1.0867 -0.0677 0.0734 1.1791 -68.8008 -4.3457)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    clipPath: "url(#SVGID_3_)",
    fill: "url(#SVGID_5_)",
    d: "M178.906,50.542 c-17.204-22.111-60.599-13.186-96.925,19.936C45.655,103.6,30.153,148.374,47.358,170.484 c17.204,22.111,60.599,13.187,96.925-19.936C180.61,117.427,196.11,72.653,178.906,50.542z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.46,
    clipPath: "url(#SVGID_3_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#969499",
    d: "M206.027,30.876c31.792,25.35,52.17,64.406,52.17,108.229c0,76.41-61.944,138.354-138.354,138.354 c-15.436,0-30.279-2.53-44.144-7.194c23.643,18.853,53.596,30.126,86.185,30.126c76.411,0,138.354-61.943,138.354-138.354 C300.238,101.061,260.792,49.3,206.027,30.876z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigYellowPlanet);
export default __webpack_public_path__ + "static/media/big-yellow-planet.9d3d0d890878a78baa9bbdadd47bca1c.svg";
export { ForwardRef as ReactComponent };